import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'questionnaire-tag',
  templateUrl: './questionnaire-tag.component.html',
  styleUrls: ['./questionnaire-tag.component.css']
})

export class QuestionnaireTagComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() questionnaireTagArray: any; //问卷标签
  @Input() questionnaireContext: string; //富文本内容
  @Output() outPutSelectedTag = new EventEmitter<any>(); //回传标签


  selectedTag: string = ""; //用户选择的标签

  constructor(private el: ElementRef,
              private renderer: Renderer2) {}

  ngOnInit() {

  }

  ngAfterViewInit(){

  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.questionnaireContext && changes.questionnaireContext.currentValue !==''){
      localStorage.setItem('inputContext',this.questionnaireContext);
    }
  }

  // 选择标签
  selectTag(i){
    let inputContext = localStorage.getItem('inputContext') ? localStorage.getItem('inputContext'): '';

    let target = this.el.nativeElement.querySelector('.elem-'+i);
    if(target.classList.contains('active') == true){
      this.renderer.removeClass(target, 'active');
      // this.selectedTagArray.splice(this.selectedTagArray.findIndex(item => item === this.questionnaireTagArray[i].description),1);
      // this.selectedTag = this.inputContext.replace(this.questionnaireTagArray[i].description+',', '');
      this.selectedTag = inputContext.replace(this.questionnaireTagArray[i].description+',', '');
      localStorage.setItem('inputContext',this.selectedTag);
    }else{
      // this.renderer.addClass(target, 'active');
      // this.selectedTagArray.push(this.questionnaireTagArray[i].description);
      if(inputContext.length >= 300){
        return false;
      }else{
        this.renderer.addClass(target, 'active');
        this.selectedTag = inputContext + this.questionnaireTagArray[i].description+',';
        // this.selectedTag += this.questionnaireTagArray[i].description+',';
      }
    }
    this.outPutSelectedTag.emit(this.selectedTag);
  }


}



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-tag/questionnaire-tag.component.ts